/**
 * Created by laszlo.czondor on 2017. 10. 26.
 */


export default {
	strict: process.env.NODE_ENV !== 'production'
};



// WEBPACK FOOTER //
// ../source/common/central-vuex-store/central.vuex.js